var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToDoList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    height: "1em",
    width: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M723.009 949.816L906.324 764.744C911.637 759.379 915.945 748.909 915.945 741.358L915.945 207.982C915.945 175.781 889.841 149.677 857.641 149.677L230.337 149.677C198.137 149.677 172.033 175.781 172.033 207.982L172.033 898.51C172.033 930.711 198.137 956.815 230.337 956.815L699.716 958.453C707.267 958.496 717.695 955.181 723.009 949.816Z",
    fill: "#ffd668",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.059 762.397C874.713 777.663 848.281 768.543 766.119 758.185C736.919 754.504 721.672 778.273 721.642 802.808C721.642 802.808 716.408 951.832 711.105 956.182C709.853 957.208 709.65 957.047 713.103 955.803C749.305 942.771 906.172 765.233 906.172 765.233C910.45 759.281 911.62 759.688 906.059 762.397Z",
    fill: "#f1ba29",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.085 903.637L866.399 718.565C871.713 713.2 876.021 702.73 876.021 695.179L876.021 161.803C876.021 129.602 849.917 103.499 817.717 103.499L190.413 103.499C158.212 103.499 132.109 129.602 132.109 161.803L132.109 852.332C132.109 884.532 158.212 910.636 190.413 910.636L659.791 912.274C667.342 912.317 677.771 909.002 683.085 903.637Z",
    fill: "#70e6dd",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.134 716.218C834.789 731.484 808.356 722.364 726.195 712.006C696.995 708.326 681.747 732.094 681.717 756.629C681.717 756.629 676.484 905.653 671.18 910.003C669.929 911.029 669.726 910.868 673.179 909.624C709.381 896.592 866.248 719.054 866.248 719.054C870.526 713.102 871.696 713.509 866.134 716.218Z",
    fill: "#33bbb1",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.016 281.629L269.589 281.629C274.401 281.629 278.302 285.677 278.302 290.671L278.302 341.838C278.302 346.832 274.401 350.88 269.589 350.88L217.016 350.88C212.203 350.88 208.302 346.832 208.302 341.838L208.302 290.671C208.302 285.677 212.203 281.629 217.016 281.629Z",
    fill: "none",
    opacity: 1,
    stroke: "#3b3b3b",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.435 423.43L271.008 423.43C275.82 423.43 279.721 427.478 279.721 432.471L279.721 483.639C279.721 488.632 275.82 492.68 271.008 492.68L218.435 492.68C213.622 492.68 209.721 488.632 209.721 483.639L209.721 432.471C209.721 427.478 213.622 423.43 218.435 423.43Z",
    fill: "none",
    opacity: 1,
    stroke: "#3b3b3b",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.016 567.403L269.589 567.403C274.401 567.403 278.302 571.451 278.302 576.444L278.302 627.612C278.302 632.605 274.401 636.653 269.589 636.653L217.016 636.653C212.203 636.653 208.302 632.605 208.302 627.612L208.302 576.444C208.302 571.451 212.203 567.403 217.016 567.403Z",
    fill: "none",
    opacity: 1,
    stroke: "#3b3b3b",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.989 341.062L796.989 341.768",
    fill: "none",
    opacity: 1,
    stroke: "#3b3b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.408 482.863L798.408 483.569",
    fill: "none",
    opacity: 1,
    stroke: "#3b3b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.989 626.836L726.989 627.432",
    fill: "none",
    opacity: 1,
    stroke: "#3b3b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.69 154.107L420.495 151.61",
    fill: "none",
    opacity: 1,
    stroke: "#3b3b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.402 165.346L387.154 231.532",
    fill: "none",
    opacity: 1,
    stroke: "#3b3b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.593 187.227L448.593 187.227C459.972 187.227 469.198 196.997 469.198 209.049L469.198 209.71C469.198 221.762 459.972 231.532 448.593 231.532L448.593 231.532C437.213 231.532 427.988 221.762 427.988 209.71L427.988 209.049C427.988 196.997 437.213 187.227 448.593 187.227Z",
    fill: "none",
    opacity: 1,
    stroke: "#3b3b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.705 187.227L646.705 187.227C658.085 187.227 667.31 196.997 667.31 209.049L667.31 209.71C667.31 221.762 658.085 231.532 646.705 231.532L646.705 231.532C635.325 231.532 626.1 221.762 626.1 209.71L626.1 209.049C626.1 196.997 635.325 187.227 646.705 187.227Z",
    fill: "none",
    opacity: 1,
    stroke: "#3b3b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.89 156.605L591.89 230.907",
    fill: "none",
    opacity: 1,
    stroke: "#3b3b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.746 188.725L571.475 188.725C580.232 188.725 587.331 198.392 587.331 210.316L587.331 210.316C587.331 222.241 580.232 231.907 571.475 231.907L563.746 231.907C554.989 231.907 547.89 222.241 547.89 210.316L547.89 210.316C547.89 198.392 554.989 188.725 563.746 188.725Z",
    fill: "none",
    opacity: 1,
    stroke: "#3b3b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 22
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToDoList);
export default __webpack_public_path__ + "static/media/ToDoList.70d758ec79f7055779c6d00dd36f5f0a.svg";
export { ForwardRef as ReactComponent };